// REQ-2026-10-16-5401: super-user sign-in -- a ticket number and the person's name are
// required before the key works.
//
// The SERVER is the control: a super user signing in from an untrusted address gets a key
// the API refuses (HTTP 403, `super_attest_required: 1`) on every call except
// POST /V1/auth/super_attest. The dialog (components/AppLayout/SuperAttestModal.js) only
// collects the two fields.
//
// Three ways a pending key reaches the app, one place each:
//   - a login response carrying super_attest_required (Login.js: token and password
//     paths; Common/Modal.js + Form.js: Entra SSO) -> openSuperAttest(continueLogin), so
//     the app does not navigate until the user has attested;
//   - any API call refused with the attest-required 403 (a reload, an old ndAPIKey
//     cookie) -> the axios interceptor below opens it; on success the page reloads so
//     every view refetches with the now-working key.
//
// Each of those also carries the SUPPORT AUTHORIZATION NOTICE the dialog shows
// (`super_attest_notice`: {version, date, text}); it is kept in auth.superAttestNotice.

import axios from 'axios';

let store = null;
let afterAttest = [];

export function bindSuperAttest(reduxStore) {
  store = reduxStore;
  // There was no response interceptor anywhere in src/ before this; it passes every
  // response and error through untouched and only LOOKS for the attest-required 403.
  axios.interceptors.response.use(
    response => response,
    error => {
      if (isSuperAttestRefusal(error && error.response)) {
        openSuperAttest(null, error.response.data.super_attest_notice);
      }
      return Promise.reject(error);
    },
  );
}

export function isSuperAttestRefusal(response) {
  return !!(response && response.status === 403 && response.data && response.data.super_attest_required);
}

// Open the dialog. `continueWith` runs once the key has been attested -- the login paths
// pass the navigation they were about to do. With no continuation the page reloads.
// `notice` is the authorization notice the API sent with the response that asked for it.
export function openSuperAttest(continueWith, notice) {
  if (continueWith) afterAttest.push(continueWith);
  store && store.dispatch({ type: 'SUPER_ATTEST_REQUIRED', notice: notice || null });
}

export function superAttestDone() {
  const pending = afterAttest;
  afterAttest = [];
  store && store.dispatch({ type: 'SUPER_ATTEST_FULFILLED' });
  if (pending.length) {
    pending.forEach(fn => fn());
  } else {
    window.location.reload();
  }
}

export function superAttestCancelled() {
  afterAttest = [];
}
